// @ts-nocheck
import {
  Directive,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsEvent, AnalyticsService } from '../service/analytics.service';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[pTrackEvent]',
  exportAs: 'pTrackEventDirective',
})
export class TrackEventDirective {
  @Input() pTrackEvent: string;

  @Input() pTrackAction: string;

  @Input() pTrackLabel: string;

  @Input() pTrackValue: string;

  @Input() pTrackCategory: string;

  @Input() pTrackProperties: any;

  // TODO: Combine listiners in one function

  @HostListener('mouseenter') onMouseEnter() {
    const on = 'mouseenter';
    const trackOn = `${this.pTrackEvent}`.split(',');
    if (trackOn.indexOf(on) > -1) {
      this.sendEventOn(on);
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    const on = 'mouseleave';
    const trackOn = `${this.pTrackEvent}`.split(',');
    if (trackOn.indexOf(on) > -1) {
      this.sendEventOn(on);
    }
  }

  @HostListener('click') onClick() {
    const on = 'click';
    const trackOn = `${this.pTrackEvent}`.split(',');
    if (trackOn.indexOf(on) > -1) {
      this.sendEventOn(on);
    }
  }

  @HostListener('blur') onBlur() {
    const on = 'blur';
    const trackOn = `${this.pTrackEvent}`.split(',');
    if (trackOn.indexOf(on) > -1) {
      this.sendEventOn(on);
    }
  }

  @HostListener('focus') onFocus() {
    const on = 'focus';
    const trackOn = `${this.pTrackEvent}`.split(',');
    if (trackOn.indexOf(on) > -1) {
      this.sendEventOn(on);
    }
  }

  constructor(
    private analytics: AnalyticsService,
    private router: Router,
  ) { }

  /**
   * on
   */
  private sendEventOn(on: string): void {
    const event: AnalyticsEvent = {
      data: {
        event: on,
        action: `${this.pTrackAction}_${on}`,
        label: this.pTrackLabel,
        properties: {
          category: this.pTrackCategory,
          value: this.pTrackValue,
          route: this.router.url,
        },
      },
    };
    //
    Object.keys(event.data).forEach((key) => {
      if (!event.data[key]) { delete event.data[key]; }
    });
    //
    this.analytics.eventTrack(event);
  }
}
